import { getAccessTokenFromCookie } from "../../util/authentication";
import { CFG_FA_GO, SYSTEM_API_COMMON_CONFIG } from "../../util/constants";

// GET functions
export const getFeaturesAndChildItems = async () => {
  const apiEndpoint = process.env.REACT_APP_SYSTEM_SERVICE_API + SYSTEM_API_COMMON_CONFIG + "/" + CFG_FA_GO.NAME + "/" + CFG_FA_GO.FEATURE;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
  } catch (error) {
    console.log(error)
    return null;
  }
}

export const getAllAccessLinks = async () => {
  const apiEndpoint = process.env.REACT_APP_SYSTEM_SERVICE_API + SYSTEM_API_COMMON_CONFIG + "/" + CFG_FA_GO.NAME + "/" + CFG_FA_GO.ACCESS_LINKS;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response;
  } catch (error) {
    console.log(error)
    return null;
  }
}